import React from 'react';
import * as Icon from 'react-feather';

const SuIcecekOzellikler = () => {
    return (
        <div className="features-area pt-80 pb-50 bg-f9f6f6">
            <div className="container">
                <div className="section-title">
                    <h2>Özellikler</h2>
                    <p>
                        Su ve içecek ihtiyaçlarının mobil uygulama üzerinden hızlıca sipariş edilmesini, güvenli ödeme yapılmasını ve teslimat sürecinin anlık olarak takip edilmesini sağlayan kullanıcı dostu bir platformdur.
                    </p>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon">
                                <Icon.Grid />
                            </div>
                            <h3>Geniş Ürün Seçeneği</h3>
                            <p>
                                Su, meşrubat ve farklı içecek kategorilerini tek uygulamada görüntüleme.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon">
                                <Icon.MapPin />
                            </div>
                            <h3>Konum Bazlı Sipariş</h3>
                            <p>
                                Kullanıcının adresine hizmet veren en yakın satıcıdan sipariş oluşturma.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon bg-c679e3">
                                <Icon.Truck />
                            </div>
                            <h3>Anlık Sipariş Takibi</h3>
                            <p>
                                Siparişin hazırlanma ve teslimat sürecini uygulama üzerinden takip etme.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon bg-c679e3">
                                <Icon.CreditCard />
                            </div>
                            <h3>Güvenli Ödeme</h3>
                            <p>
                                Online ödeme veya kapıda ödeme seçenekleriyle kolay sipariş verme.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon bg-eb6b3d">
                                <Icon.RefreshCw />
                            </div>
                            <h3>Hızlı Tekrar Sipariş</h3>
                            <p>
                                Geçmiş siparişleri tek dokunuşla yeniden oluşturma.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon bg-eb6b3d">
                                <Icon.Bell />
                            </div>
                            <h3>Kampanya ve Bildirimler</h3>
                            <p>
                                İndirimler, kampanyalar ve sipariş durumu hakkında anlık bildirim alma.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SuIcecekOzellikler;
